"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestPattern = exports.requestLogFormat = exports.RequestBuilder = void 0;
const utils_1 = require("./utils");
const Pattern_1 = require("./Pattern");
class RequestBuilder {
    _data;
    _type;
    constructor(_data, _type) {
        this._data = _data;
        this._type = _type;
    }
    url() {
        return (0, utils_1.buildUrl)(this._data);
    }
    prefix() {
        return `[${this._type.toLocaleUpperCase()} REQUEST]`;
    }
    date() {
        return (0, utils_1.buildDate)();
    }
    method() {
        return this._data.method?.toLocaleUpperCase() ?? 'GET';
    }
    headers() {
        return JSON.stringify(this._data.headers);
    }
    params() {
        return this._data.data ? JSON.stringify(this._data.data) : '';
    }
    requestId() {
        return this._data.requestId?.toString() ?? '';
    }
}
exports.RequestBuilder = RequestBuilder;
exports.requestLogFormat = '{prefix} <id:{requestId}> {date} {method} {url} {params}';
exports.requestPattern = new Pattern_1.Pattern([
    'prefix', 'date', 'method', 'url',
    'headers', 'params', 'requestId'
]);
//# sourceMappingURL=RequestBuilder.js.map